import { LVTMetricData } from '../types';

export const LVT_METRIC_CHECKOUT_ANALYSIS_STORAGE_KEYS = {
  stepName: 'stepName',
  startCheckoutTime: 'startCheckoutTime',
  closedWebsiteAt: 'closedWebsiteAt',
  sessionId: 'sessionId',
  entryStepName: 'entryStepName',
  basketId: 'basketId',
  paymentMethod: 'paymentMethod',
} as const;

export const LVT_METRIC_CHECKOUT_ANALYSIS_STEPS: {
  [K in Uppercase<
    NonNullable<LVTMetricData<'checkout_analysis'>['eventStep']>
  >]: NonNullable<LVTMetricData<'checkout_analysis'>['eventStep']>;
} = {
  SCHOOLS_CPD_EVENTS_ENTRY: 'schools_cpd_events_entry',
  SCHOOLS_CPD_EVENTS_ADD_TO_BASKET: 'schools_cpd_events_add_to_basket',
  CHECKOUT_COMPLETED: 'checkout_completed',
  CHECKOUT_ABANDONED: 'checkout_abandoned',
};

export const PAYMENT_OPTIONS = {
  CARD: 'card',
  PAYPAL: 'paypal',
  GIFT_CERTIFICATE: 'gift-certificate',
  OTHER: 'other',
} as const;
